import React,{ useEffect, useState, useCallback } from 'react';
import debouce from 'lodash/debounce';

const Actions = ({actionItems, onActionClick, rowData, access, page}) => { 
  const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')): {};
  const userDetails = sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails')) : null;
  const availableActions = ['action_delete', 'action_editor', 'action_pdf_report', 'file_docx', 'other_vertical', 'action_download_stroke'];
  const [allowedActions, setAllowedActions] = useState(null)

  const handleActionClick = (actionType) => {
    setTimeout(() => {
      onActionClick(actionType, rowData);
    }, 100)
  }

  // debounce call
  const debouncedCall = useCallback(
    debouce(()=> {
      filterActionsAllowed();
    }, 500), //Adjusting the delay
    []
  );
  
  useEffect(() => {
    if(allowedActions == null) debouncedCall();

    //Clean up the debounce on component unmount
    return () => {
      debouncedCall.cancel();
    };
  },[allowedActions])


  const filterActionsAllowed = () => {
    let filteredActions = availableActions;
    if(!userDetails.isAdmin){
      if (access && !access.grantDelete && !access.grantUpdate) {
        setAllowedActions(['action_download_stroke'])
      }
      else if(page == 'modalTable'){
        setAllowedActions(['action_delete']);
      }
      else{
        if(!access.grantUpdate && !access.grantDelete){
          filteredActions = filteredActions.filter(v => v != 'action_editor' && v != 'other_vertical' && v != 'action_delete')
        }
        if(!access.grantUpdate && access.grantDelete){
          filteredActions = filteredActions.filter(v => v != 'action_editor' && v != 'other_vertical')
        }
        if(access.grantUpdate && !access.grantDelete){
          filteredActions = filteredActions.filter(v => v != 'action_delete')
        }
        if(access.grantDelete && access.grantUpdate) filteredActions = availableActions;

        if(page == 'product' && rowData.status == 'Published'){
          filteredActions = filteredActions.filter(v => v != 'action_delete')
          if(!dropDownData['Teams'].some(team => team.name == rowData.team)){            
            filteredActions = filteredActions.filter(v => v != 'action_editor' && v != 'other_vertical')
          }
        }
        if(page == 'product' && rowData.status == 'Test' && !dropDownData['Teams'].some(team => team.name == rowData.team)){
          filteredActions = filteredActions.filter(v => v != 'action_editor' && v != 'action_delete' && v != 'other_vertical')
        }
        if(page == 'teams' && !rowData['productOwnerID'].includes(userDetails.id)){
          filteredActions = filteredActions.filter(v => v != 'action_editor' && v != 'action_delete')
        }
        if(page == 'Firmware' && !dropDownData['ProductList'].some(product => product.name == rowData.productId) && !dropDownData['Teams'].some(team => team.name == rowData.team)){
          filteredActions = filteredActions.filter(v => v != 'action_editor' && v != 'action_delete' && v != 'other_vertical')
        }
        if(page == 'certificates' && rowData['productId'] == null){
          filteredActions = filteredActions.filter(v => v!= 'action_download_stroke')
        }
        if(page == 'revocation' && rowData['productId'] == null && rowData['docType'] == 'DAC'){
          filteredActions = filteredActions.filter(v => v!= 'action_download_stroke')
        }
        setAllowedActions(filteredActions)
      }
    }
    else {
        if(page == 'certificates' && rowData['productId'] == null){
          filteredActions = availableActions.filter(v => v!= 'action_download_stroke')
          setAllowedActions(filteredActions)
        }
        else setAllowedActions(availableActions)
    }
  }

  return (
    <div className='actionItems' key={rowData?.id+'actionDiv'}>
      <se-table-item slot='end' width='120px' min-width='120px'>
        {(allowedActions || []).map((action)=>{
          return(
              <>
                {actionItems?.includes(action) && rowData?.docType !== 'User Manual' && (
                  <se-icon key={action+rowData?.id} size='small' option='button' onClick={() => handleActionClick(action)}>
                    {action}
                  </se-icon>
                )}
              </> 
            )
          })
        }
        {rowData?.docType == 'User Manual' && (
          <se-icon key={'action_download_stroke'+rowData?.id} size='small' option='button' onClick={() => handleActionClick('action_download_stroke')}>
            action_download_stroke
          </se-icon>
        )}
      </se-table-item>
    </div>
  );
};

export default Actions;